import Immutable from 'immutable';

import {
  RECEIVE_TEAMS_LIST,
  RECEIVE_TEAM_DETAIL,
  SET_TEAM_PAGE_FILTERS,
} from './actions';
import {
  getRequestResponseMapFactory,
  setNormalizedList,
} from 'app/utils/redux_v2';

const teamsArea = (
  state = Immutable.fromJS({
    filters: {
      teamDetailPages: {},
    },
    basicTeams: {},
    teams: getRequestResponseMapFactory(),
  }),
  action
) => {
  switch (action.type) {
    case RECEIVE_TEAM_DETAIL:
      return state.setIn(
        ['teams', 'byId', action.item.id.toString()],
        Immutable.fromJS(action.item)
      );

    case RECEIVE_TEAMS_LIST: {
      return state.set(
        'teams',
        setNormalizedList(action.query, action.response, state.get('teams'))
      );
    }

    case SET_TEAM_PAGE_FILTERS:
      return state.setIn(
        ['filters', 'teamDetailPages', action.team.id.toString()],
        action.filters
      );

    default:
      return state;
  }
};

export default teamsArea;
